import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { brandlogo } from '../../assets'
import styles from './footer.module.css'

const currentYear = new Date().getFullYear()

const footerLink = [
  {
    id: 1,
    name: 'Pricing',
    link: '/pricing',
  },
  {
    id: 2,
    name: 'Privacy Policy',
    link: '/privacy',
  },

  {
    id: 3,
    name: 'Contact',
    link: '/contact',
  },
  {
    id: 4,
    name: 'Term of Service',
    link: '/tos',
  },
  {
    id: 5,
    name: 'Cookie Policy',
    link: '/cookie',
  },
]

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerwrapper}>
        <div className={styles.footerleft}>
          <Link href={'/'}>
            <div className={styles.brandImagecontainer}>
              <Image
                src={brandlogo}
                alt='circle plug brand logo'
                className={styles.brandlogo}
                quality={1}
              />
            </div>
          </Link>
          <div className={styles.desc_year}>
            <p className={styles.footerdesc}>
              Everything your community needs, all in one place.
            </p>
            <p className={styles.footeryear}>&copy; Copyright {currentYear}</p>
          </div>
        </div>
        <div className={styles.footerright}>
          <div className={styles.footerabout}>
            <p className={styles.footerlinktitle}>About</p>
            <div className={styles.footerlinks}>
              {footerLink.map(({ ...rest }) => (
                <Link
                  key={rest.id}
                  href={rest.link}
                  className={styles.footerlink}
                >
                  {rest.name}
                </Link>
              ))}
            </div>
          </div>
          <div className={styles.footersocial}>
            <p className={styles.footerlinktitle}>Social</p>
            <div className={styles.footerlinks}>
              <Link
                target={'_blank'}
                href={`https://www.twitter.com/circle_plug`}
                className={styles.footerlink}
              >
                Twitter
              </Link>
              <Link
                target={'_blank'}
                href={`https://www.linkedin.com/company/circleplug`}
                className={styles.footerlink}
              >
                LinkedIn
              </Link>
              <Link
                target={'_blank'}
                href={`https://www.instagram.com/circleplug`}
                className={styles.footerlink}
              >
                Instagram
              </Link>
              <Link
                target={'_blank'}
                href={`https://www.facebook.com/circleplug`}
                className={styles.footerlink}
              >
                Facebook
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
